import React, { useState } from "react";
import BackIcon from "@styles/all-images/icons/back-button.svg";
import HeaderComponent from "@components/common/Header/Header";
import EyeIcon from "@styles/all-images/icons/eye-blue.svg";
import ArrowDownIcon from "@styles/all-images/icons/chevron-down-grey.svg";
import FlogoIcon from "@styles/all-images/images/Flogo.png";
import ViewTermsSheetModal from "./ViewTermsSheetModal";
import TierConfigurationRejectionReason from "./TierConfigurationRejectionReason";

const TierConfigurationModule = () => {
  const [isViewTermsSheetModalOpen, setIsViewTermsSheetModalOpen] =
    useState(false);
  const [isTermsSheetOpen, setIsTermsSheetOpen] = useState(false);
  const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
  const [expandedSection, setExpandedSection] = useState("T1");

  const handleViewTermsSheet = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsTermsSheetOpen(true);
  };

  const handleCloseTermsSheet = () => {
    setIsTermsSheetOpen(false);
  };

  const handleCloseRejectionModal = () => {
    setIsRejectionModalOpen(false);
  };

  const handleRejectionSubmit = () => {
    setIsRejectionModalOpen(false);
  };

  const tiers = [
    {
      id: "T1",
      title: "Funders/ Credit Providers (T1)",
      items: Array(10).fill({
        name: "FuelCap Pty Ltd.",
        logo: FlogoIcon,
      }),
    },
    {
      id: "T2",
      title: "Insurance/ Guarantors (T2)",
      items: [],
    },
    {
      id: "T3",
      title: "System Management Console (T3)",
      items: [],
    },
    {
      id: "T4",
      title: "Wholesale Traders (T5)",
      items: [],
    },
    {
      id: "T5",
      title: "Consultants/ Brokers (T6)",
      items: [],
    },
    {
      id: "T6",
      title: "Commodity Suppliers (T7)",
      items: [],
    },
  ];

  return (
    <div className="tw-relative">
      <HeaderComponent />
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-py-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <a href="/tier-configuration">
                <img src={BackIcon} alt="Back Icon" />
              </a>
              <h1 className="tw-text-[22px] tw-ml-4 tw-font-semibold tw-text-[#232323]">
                Edit Tier Configuration
              </h1>
            </div>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="tw-p-6 tw-mt-[147px] tw-gap-6 tw-flex-col tw-flex">
        <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center tw-p-4">
            <h2 className="tw-text-base tw-font-semibold">Basic Details</h2>
          </div>
          <hr />
          <div className="tw-grid md:tw-grid-cols-3 sm:tw-grid-cols-12 tw-grid-cols-12 tw-gap-8 tw-p-8">
            <div className="tw-flex tw-flex-col tw-gap-1">
              <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                Super Trader (T4)
              </span>
              <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                Mark Robinson
              </h4>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-1">
              <span className="tw-text-sm tw-font-medium tw-text-[#809199] ">
                TS Document (Shared by the bank user - T1)
              </span>
              <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold tw-flex tw-items-center tw-gap-2">
                Terms Sheet Document 1
                <button onClick={handleViewTermsSheet}>
                  <img src={EyeIcon} alt="Eye Icon" />
                </button>
              </h4>
            </div>
          </div>
        </div>
        <div>
          <div>
            <div className="tw-full">
              {tiers.map((tier) => (
                <div
                  key={tier.id}
                  className="tw-rounded-lg tw-overflow-hidden tw-bg-[#FFFFFF] tw-border tw-border-[#E9EAEB]  tw-shadow-sm tw-my-3"
                >
                  <button
                    onClick={() =>
                      setExpandedSection(
                        expandedSection === tier.id ? "" : tier.id,
                      )
                    }
                    className={`tw-w-full tw-flex tw-items-center tw-justify-between tw-p-4 tw-text-left tw-transition-colors 
    ${expandedSection === tier.id ? "tw-bg-[#ECF1F8] tw-text-[#232323]" : ""}`} // Add this line for background color change
                  >
                    <span className="tw-font-medium">{tier.title}</span>
                    <img src={ArrowDownIcon} alt="Arrow Down Icon" />
                  </button>

                  {expandedSection === tier.id && (
                    <div className="tw-p-4 tw-bg-white tw-border-t">
                      <div className="tw-grid tw-grid-cols-4 tw-md:tw-grid-cols-2 tw-lg:tw-grid-cols-4 tw-gap-4">
                        {tier.items.map((item, index) => (
                          <div
                            key={index}
                            className="tw-px-4 tw-py-3 tw-bg-white tw-rounded-lg tw-border tw-border-[#E9EAEB] tw-flex tw-items-center tw-justify-between tw-space-x-3"
                          >
                            <div className="tw-flex tw-items-center tw-gap-2">
                              <span className="tw-text-blue-500 tw-text-xl">
                                <img
                                  src={item.logo}
                                  alt={item.name + " Logo"}
                                  className="tw-w-5 tw-h-5"
                                />
                              </span>
                              <span className="tw-text-gray-700">
                                {item.name}
                              </span>
                            </div>
                            <input
                              type="checkbox"
                              className="tw-ml-auto tw-w-4 tw-h-4 tw-text-blue-600 tw-rounded tw-border-gray-300 tw-focus:tw-ring-blue-500"
                            />
                          </div>
                        ))}
                      </div>
                      {tier.items.length === 0 && (
                        <div className="tw-text-gray-500 tw-text-center tw-py-4">
                          No items available
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}

              <div className="tw-flex tw-justify-center tw-mt-4">
                <button className="tw-bg-blue-600 hover:tw-bg-blue-700 tw-flex tw-items-center tw-gap-2 tw-w-auto tw-justify-center tw-text-white tw-rounded-md tw-px-4 tw-py-2 primary-custom-button">
                  Add Tier Configuration
                </button>
              </div>
            </div>
          </div>
        </div>
        {isViewTermsSheetModalOpen && (
          <ViewTermsSheetModal
            onClose={() => setIsViewTermsSheetModalOpen(true)}
          />
        )}
        {isTermsSheetOpen && (
          <ViewTermsSheetModal onClose={handleCloseTermsSheet} />
        )}

        <div>
          {isRejectionModalOpen && (
            <TierConfigurationRejectionReason
              onClose={handleCloseRejectionModal}
              onSubmit={handleRejectionSubmit}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TierConfigurationModule;
